<template>
  <b-modal :ref="modalName"
           :title="modalTitle"
           bg-variant="light"
           centered
           content-class="confirm-modal-content"
           dialog-class="confirm-modal-dialog"
           header-bg-variant="dark"
           header-text-variant="white"
           hide-footer
           lazy
           size="full-response"
           v-bind="$attrs"
           @hidden="hide">
    <slot/>
    <div class="btn-container">
      <b-btn class="ml-auto"
             variant="info"
             @click="hide"
             v-text="buttonTitle"/>
    </div>
  </b-modal>
</template>

<script>
  import { baseModalsMixin } from '@/mixins/baseModals';

  export default {
    name: 'BaseInfoModal',
    mixins: [baseModalsMixin],
    props: {
      buttonTitle: {
        type: String,
        default: 'Ok',
      },
    },
  };
</script>

<style lang="scss" scoped>
  $sm-width: 575px;

  .btn-container {
    display: flex;
    justify-content: space-between;
  }

  .btn-warning {
    color: white;
  }

  ::v-deep .confirm-modal-content {
    @media (max-width: $sm-width) {
      width: 600px !important;
      top: 12rem !important;
    }
  }

  ::v-deep .confirm-modal-dialog {
    @media (max-width: $sm-width) {
      align-items: unset !important;
      justify-content: center !important;
      min-height: unset !important;
    }
  }

  ::v-deep .modal-backdrop {
    width: 100% !important;
    height: calc(100vh - calc(100vh - 100%));
  }
</style>
